import comSpSkeleton from "../../../../engines/components/comSpSkeleton";
import gameConfig from "../../../../engines/configs/gameConfig";
import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../BundleResourceConfig";
import clamShellManager from "../../manager/clamShellManager";
import NormalGameManager from "../../manager/NormalGameManager";
import { clamShellEndInterface, clamShellEventInterface, clamShellStartInterface } from "./clamShellConst";
import clamShellGame from "./clamShellGame";
const {ccclass, property} = cc._decorator;

@ccclass
export default class clamShellGameObj extends cc.Component {

    @property({type:cc.Node,displayName:"贝壳的底"})
    showSp:cc.Node = null;

    @property({type:cc.Node,displayName:"贝壳的壳"})
    shellSp:cc.Node = null;

    @property({type:cc.Node,displayName:"珍珠节点"})
    pearlSp:cc.Node = null;

    @property({type:cc.Node,displayName:"价格的标"})
    priceNode:cc.Node = null;

    startData:clamShellStartInterface = null;

    endData:clamShellEndInterface = null;

    gameScript:clamShellGame = null;

    canClick:boolean = true;

    isHaveBiao:boolean = false;

    initPos:cc.Vec2 = null;

    event:clamShellEventInterface = null;

    clamShellManager:clamShellManager = null;

    onLoad(){
        this.node.on("touchend",this.onBtnClick,this);
        this.showSp.zIndex = -1;
        this.shellSp.zIndex = 5;
        this.priceNode.zIndex = 6;
    }

    start(): void {
        this.initPos = this.node.getPosition().clone();
    }

    bindDate(startData:clamShellStartInterface,endData:clamShellEndInterface,gameScript:clamShellGame,isHaveBiao:boolean){
        this.clamShellManager = NormalGameManager._instance.clamShellManager;
        this.isHaveBiao = isHaveBiao;
        this.startData = startData;
        this.startData.price = Math.floor( NormalGameManager._instance.getPriceRate() * this.startData.price );
        this.endData = endData;
        this.gameScript = gameScript;
        this.loadEvent();
        this.loadIcon();
        this.updatePrice();
    }

    loadIcon(){
        let iconPath = this.startData.icon;
        if(iconPath){
            // 加载icon
            //上
            let above:string = iconPath.replace("下","上");
            //下
            let below:string = iconPath.replace("上","下");
            getOneBundleByInstant(BUNDLE_SMALL_NAME.clamShellGameBundle).load(`clamShellGameAssets/clamShell/${above}`,cc.SpriteFrame,(err,asset:cc.SpriteFrame)=>{
                if(err){
                    console.log("加载贝壳上面的图片失败",err)
                    return;
                }
                this.shellSp.getComponent(cc.Sprite).spriteFrame = asset;
                this.scheduleOnce(()=>{
                    this.node.width = this.showSp.width;
                    this.node.height = this.showSp.height;
                });
            });
            getOneBundleByInstant(BUNDLE_SMALL_NAME.clamShellGameBundle).load(`clamShellGameAssets/clamShell/${below}`,cc.SpriteFrame,(err,asset:cc.SpriteFrame)=>{
                if(err){
                    console.log("加载贝壳下面的图片失败",err)
                    return;
                }
                this.showSp.getComponent(cc.Sprite).spriteFrame = asset;
                this.scheduleOnce(()=>{
                    this.node.width = this.showSp.width;
                    this.node.height = this.showSp.height;
                });
            });
        }

        let pearlPath:string = this.endData.incision;
        if(this.event){
            pearlPath = this.clamShellManager.getOnePearlSpPath(this);
        }
        if(pearlPath){
            getOneBundleByInstant(BUNDLE_SMALL_NAME.clamShellGameBundle).load(`clamShellGameAssets/pearl/${pearlPath}`,cc.SpriteFrame,(err,asset:cc.SpriteFrame)=>{
                if(err){
                    console.log("加载珍珠图片失败",err)
                    return;
                }
                this.pearlSp.getComponent(cc.Sprite).spriteFrame = asset;
            });
        }
    }

    loadEvent(){
        let endData = this.endData;
        let events:number[] = endData.Emergency;
        let certain = endData.certain;
        // if(certain == 1){
            // 会必定
            // this.event = this.clamShellManager.getOneClamShellRandEvent(this);
        // }else{
        //     // 按照设定的概率来
        //     if(Math.random() < gameConfig.GAMBLER_EVENT_PRO && events.length>0){
        //         // 有事件 按照权重来
        //         this.event = this.clamShellManager.getOneClamShellRandEvent(this);
        //     }
        // }
    }

    updatePrice(){
        if(!this.canClick){
            this.priceNode.active = this.canClick;
            return;
        }
        this.priceNode.active = this.isHaveBiao;
        let priceLb:cc.Label = this.priceNode.getChildByName("label").getComponent(cc.Label);
        priceLb.string = data_control.getNumberFormat(this.startData.price);
    }

    //打开贝壳动画
    async openAni(){
        return new Promise<void>(resolve=>{
            let needTime:number = 1.5;
            cc.tween(this.shellSp).to(needTime,{x:-this.shellSp.width}).to(needTime,{opacity:0}).start();
            this.scheduleOnce(resolve,needTime * 2);
        });
    }

    onBtnClick(){
        if(this.canClick){
            O1HD.getManagers().soundMgr.playSound("anNiu");
            this.gameScript?.startExplain(this.node);
        }
    }

}
